function sortQuestionsById(questions) {
  if (!questions) return [];
  return [...questions].sort((a, b) => a.id - b.id);
}

function sortPageQuestions(page) {
  if (!page) return page;
  return {
    ...page,
    questions: sortQuestionsById(page.questions),
  };
}

module.exports = { sortQuestionsById, sortPageQuestions };
